<template>
    <div
        class="ppv2-flex ppv2-flex-col ppv2-items-center ppv2-text-center ppv2-p-8 ppv2-h-full ppv2-justify-center ppv2-items-center"
    >
        <div class="ppv2-relative ppv2-mb-6">
            <div
                class="ppv2-absolute ppv2-rounded-full"
                style="
                    width: 76px;
                    height: 76px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(125, 45, 189, 0.1);
                    animation: pulseRing 2.4s ease-in-out infinite;
                "
            ></div>
            <div class="icon-circle ppv2-relative" style="z-index: 1">
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
            </div>
        </div>

        <h6 class="poppinsSemiBold !ppv2-text-white ppv2-opacity-80 ppv2-mb-2">
            {{ $t('widgetIntegration.defaultPreviewTitle') }}
        </h6>
        <p class="ppv2-text-sm ppv2-mb-0 !ppv2-text-white ppv2-text-opacity-70" style="max-width: 270px; line-height: 1.65">
            {{ $t('widgetIntegration.defaultPreviewDescription') }}
        </p>

        <div class="ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-mt-6">
            <div style="height: 1px; width: 36px; background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.07))"></div>
            <span
                class="poppinsMedium ppv2-uppercase"
                style="color: rgba(0, 0, 0, 0.15); font-size: 0.65rem; letter-spacing: 0.12em"
                >Playpro Widgets</span
            >
            <div style="height: 1px; width: 36px; background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.07))"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DefaultWidget',
}
</script>

<style scoped>
.icon-circle {
    width: 52px;
    height: 52px;
    background-color: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
}

@keyframes pulseRing {
    0% {
        transform: translate(-50%, -50%) scale(0.85);
        opacity: 0.6;
    }
    50% {
        transform: translate(-50%, -50%) scale(1.2);
        opacity: 0.15;
    }
    100% {
        transform: translate(-50%, -50%) scale(0.85);
        opacity: 0.6;
    }
}
</style>
